<template>
  <v-toolbar flat class="stick">
    <v-toolbar-title class="headline primary--text font-weight-medium">
      {{ title }}
    </v-toolbar-title>
    <v-icon v-if="showDeleteButton" class="mx-2" @click="onDeleteClick"
      >mdi-delete</v-icon
    >
    <v-spacer></v-spacer>
    <v-btn
      v-if="showSubmitButton"
      class="mr-2 white--text font-weight-bold"
      color="primary"
      @click="onSubmitClick"
      :disabled="disableSubmitValue"
      :loading="isSubmitting"
    >
      <v-icon left>mdi-check</v-icon>
      Submit
    </v-btn>
    <v-btn icon v-if="onCloseClick">
      <v-icon class="heading grey--text text--darken-4" @click="onCloseClick">
        mdi-close
      </v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Form Title',
    },
    showSubmitButton: {
      type: Boolean,
      default: true,
    },
    onSubmitClick: Function,
    onCloseClick: Function,
    disableSubmitValue: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDeleteButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    onDeleteClick: {
      type: Function,
      required: false,
      default: null,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
.stick {
  position: sticky;
  top: 0;
  z-index: 999;
}
</style>
